export default "__VITE_ASSET__989d4089__"